<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CwEG6R/tc-custom/9781460349854.jpg?1718044032458" alt="This image is the cover for the book Redemption of Darius Sterne, The Twin Tycoons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Redemption of Darius Sterne, The Twin Tycoons
      </h1>
      <p class="bookDescription body article font2">
        <i>An Entertainment Weekly Top 10 Romance Author</i><br/><br/><b><i>So innocent… So tempting…</i></b><br/><br/>Having built a global empire synonymous with excellence, formidable tycoon Darius Sterne is a man who gets what he wants. Always. And right now? He wants ex-ballerina Miranda Jacobs…in his bed and sighing his name in pleasure.<br/><br/>Virginal Miranda can't resist the allure of the brooding billionaire. But the closer he pulls her, the more Darius threatens the barriers she's carefully constructed to conceal the scars of her past. Yet Miranda isn't the only one with pain to hide…<br/><br/>Can her pure love dance into his heart and redeem the dark and damaged Darius Sterne?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carole Mortimer
      </h2>
      
      <p class="authorDescription body article">Carole Mortimer was born in England, the youngest of three children. She began writing in 1978, and has now written over one hundred and seventy books for Harlequin Mills and Boon&reg;. Carole has six sons, Matthew, Joshua, Timothy, Michael, David and Peter. She says, &lsquo;I&rsquo;m happily married to Peter senior; we&rsquo;re best friends as well as lovers, which is probably the best recipe for a successful relationship. We live in a lovely part of England.&rsquo;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78db89dd